function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.702,
    height: 16.943,
    viewBox: "0 0 5.477 4.483"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      overflow: "hidden",
      fill: "#a00"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.2 480c-85.44-96-218.24-151.68-384-160V175.04A43.2 43.2 0 0 0 465.92 136a44.8 44.8 0 0 0-46.08 5.44L38.4 443.2a42.56 42.56 0 0 0 0 66.88l380.16 304.64a44.8 44.8 0 0 0 46.4 5.76 42.88 42.88 0 0 0 25.28-39.04V633.28c384 5.44 411.52 241.28 412.48 251.2a40.96 40.96 0 0 0 38.72 39.04h2.24a41.92 41.92 0 0 0 41.6-36.48c.32-1.92 35.84-242.24-110.08-407.04m-428.8-74.56c160 0 286.08 45.12 362.24 130.56a384 384 0 0 1 81.28 153.92c-71.36-73.28-192-142.4-443.52-142.4a44.16 44.16 0 0 0-32 12.48 41.92 41.92 0 0 0-13.12 32v100.8L136 476.8l266.24-211.84v96a43.52 43.52 0 0 0 43.84 44.16zm497.28 503.68",
    style: {
      fill: "#a00"
    },
    transform: "matrix(.00566 0 0 .00566 -.126 -.747)"
  })));
};
export default SvgReply;